import {
  AiCompanionSessionContext,
  TrustedOnboardingProfileFields,
  WorkflowDynamicVariables,
} from './types';
import { TypeOfUser } from '../helpers/Constants';

export const getTrustedOnboardingProfileFields = ({
  contactPreferenceOptions = [],
  firstName,
  lastName,
  preferredLanguageId,
  preferredReplacementDurationOptions = [],
  professionalCapacityOptions = [],
  professionalType,
  provinceOptions = [],
  softwareOptions = [],
}: AiCompanionSessionContext): TrustedOnboardingProfileFields =>
  ({
    catalogs: {
      contactPreferenceOptions,
      preferredReplacementDurationOptions,
      professionalCapacityOptions,
      provinceOptions,
      softwareOptions,
    },
    firstName,
    lastName,
    preferdLanguage: preferredLanguageId,
    role: TypeOfUser[professionalType],
  });

const maxWorkflowFullNameLength = 100;

/**
 * `full_name` is interpolated into the agent's system prompt, so a signup name
 * is attacker-controlled text sitting inside the trusted instruction context.
 * The signup name validator permits any Unicode letter plus whitespace, and
 * whitespace includes newlines, so an unsanitized value could otherwise spoof a
 * prompt section. Collapse every whitespace run to a single space, drop the
 * braces used by the prompt template, and cap the length.
 */
export const sanitizeWorkflowFullName = (fullName: string) =>
  fullName
    .replace(/[{}]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, maxWorkflowFullNameLength)
    .trim();

export const buildWorkflowDynamicVariables = (
  {
    email,
    firstName,
    lastName,
    preferredLanguage,
    preferredLanguageId,
    professionalType,
    professionalCapacityOptions,
    softwareOptions,
    contactPreferenceOptions,
    provinceOptions,
    preferredReplacementDurationOptions,
  }: AiCompanionSessionContext,
): WorkflowDynamicVariables =>
  ({
    contact_preference_options_json: JSON.stringify(
      contactPreferenceOptions ?? [],
    ),
    email,
    full_name: sanitizeWorkflowFullName(`${firstName} ${lastName}`),
    preferred_language: preferredLanguage,
    preferred_language_id: preferredLanguageId,
    preferred_replacement_duration_options_json: JSON.stringify(
      preferredReplacementDurationOptions ?? [],
    ),
    professional_capacity_options_json: JSON.stringify(
      professionalCapacityOptions ?? [],
    ),
    professional_type: professionalType,
    province_options_json: JSON.stringify(provinceOptions ?? []),
    software_options_json: JSON.stringify(softwareOptions ?? []),
  });
